import React, { Suspense, lazy } from "react";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProtectedRoute from "components/ProtectedRoute";

// Main landing page - load immediately
import AgentOpsPage from './pages/agentops';

// Lazy load other routes
const Impressum = lazy(() => import('./pages/impressum'));
const Datenschutz = lazy(() => import('./pages/datenschutz'));
const CustomerHub = lazy(() => import('./pages/customerhub'));

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>
);

const Routes = () => {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <RouterRoutes>
          <Route path="/" element={<AgentOpsPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route
            path="/customerhub"
            element={
              <ProtectedRoute>
                <CustomerHub />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </Suspense>
    </ErrorBoundary>
  );
};

export default Routes;
